import { useInfiniteQuery } from '@tanstack/react-query';
import { useSnackbar } from 'notistack';
import { useSearchParams } from 'react-router-dom';

import CompanyService from '@services/CompanyService';

import { useAuth } from '@hooks';
import { toastifyApiErrors } from '@utils';

const useCompaniesRelatedList = () => {
  const { enqueueSnackbar } = useSnackbar();

  const { selectedCompany, selectedPartnerCompany } = useAuth();

  const companyId = selectedCompany?.id ?? '';

  const partnerCompany = selectedPartnerCompany?.partnerCompany ?? '';

  const [params] = useSearchParams();
  const search = params.get('searchOrgGroup') || '';
  const relatedService = new CompanyService();

  const listRelatedCompanies = useInfiniteQuery({
    queryKey: ['companiesRelatedList', search, companyId, partnerCompany],
    queryFn: ({ pageParam = 0 }) =>
      relatedService.fetchCompaniesList({
        id: companyId,
        limit: 10,
        offset: pageParam,
        search,
      }),

    getNextPageParam: (lastPage, allPages) => {
      const companiesHasNextPage = lastPage.total > allPages.length * 9;

      if (companiesHasNextPage) {
        return allPages.length + 1;
      }

      return undefined;
    },
    onError: (error: unknown) => {
      toastifyApiErrors(error, enqueueSnackbar);
    },
    select: data => ({
      ...data,
      pages: data.pages.flatMap(page => page.companies),
    }),
  });

  return {
    listRelatedCompanies,
  };
};

export default useCompaniesRelatedList;
